
import {  ChevronRight,Facebook, Instagram, Linkedin, Twitter,MapPin,Mail,Phone,Loader } from 'lucide-react';
 

import logo from './assets/img/AngoNet.png';
import { Link } from "react-router-dom";
import api from './api/Api';
import React, { useEffect, useState } from "react";
 import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


export default function Footer({ isDarkMode }) {
const [services, setServices] = useState([]);
const [email, setEmail] = useState('');
const [loadingSubmit, setLoadingSubmit] = useState(false);


useEffect(() => {
  const fetchServices = async () => {
    try {
      const response = await api.ListServico();

      const dados = Array.isArray(response) ? response : [];

      const formatado = dados.map(item => ({
        title: item.titulo,
        code: item.code
      }));

      setServices(formatado);
    } catch (error) {
      console.error("Erro ao buscar serviços no footer:", error);
    }
  };

  fetchServices();
}, []);




const handleSubmit = async (e) => {
  e.preventDefault();

  if (!email) return;

  setLoadingSubmit(true);

  try {
    const payload = { email };

    const response = await api.AddContacto(payload);

    if (response) {
      toast.success('Inscrição realizada com sucesso!');
      setEmail('');
    }

  } catch (error) {
    const errorMsg = error.response?.data?.message || 'Erro. Tente novamente.';
    toast.error(errorMsg);
  } finally {
    setLoadingSubmit(false);
  }
};







  return (
 
      <footer id="contact" className={`relative border-t ${
        isDarkMode ? 'bg-gray-900 border-white/10' : 'bg-white border-gray-200'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-16">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            {/* Company Info */}
            <div className="lg:col-span-1">
           <div className="mb-4">
              <Link to="/">
  <img 
    src={logo} 
    alt="AngoNet Logo"
    className="h-30 object-contain"
  />
  </Link>
</div>

              <p className={`text-sm mb-6 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                Transformando empresas através da tecnologia e inovação. 
                Soluções completas para o mercado angolano.
              </p>
              {/* Social Media */}
              <div className="flex space-x-4">
                <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/p/AngoNet-Com%C3%A9rcio-e-Presta%C3%A7%C3%A3o-de-Servi%C3%A7o-100094532778927/"
                 className={`p-2 rounded-full transition-all ${
                  isDarkMode
                    ? 'bg-white/10 hover:bg-blue-500 text-gray-400 hover:text-white'
                    : 'bg-gray-100 hover:bg-blue-500 text-gray-600 hover:text-white'
                }`}>
                  <Facebook size={20} />
                </a>
                <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.instagram.com/_angonet/" 
                className={`p-2 rounded-full transition-all ${
                  isDarkMode
                    ? 'bg-white/10 hover:bg-gradient-to-r hover:from-purple-500 hover:to-pink-500 text-gray-400 hover:text-white'
                    : 'bg-gray-100 hover:bg-gradient-to-r hover:from-purple-500 hover:to-pink-500 text-gray-600 hover:text-white'
                }`}>
                  <Instagram size={20} />
                </a>
                <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.linkedin.com/company/angonet/?viewAsMember=true" 
                className={`p-2 rounded-full transition-all ${
                  isDarkMode
                    ? 'bg-white/10 hover:bg-blue-600 text-gray-400 hover:text-white'
                    : 'bg-gray-100 hover:bg-blue-600 text-gray-600 hover:text-white'
                }`}>
                  <Linkedin size={20} />
                </a>
 
              </div>
            </div>
            
            {/* Services */}
            <div>
              <h4 className={`font-bold mb-4 text-lg ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Serviços</h4>
              <ul className="space-y-3">
  {services.map((service, index) => (
    <li key={index}>
      <Link
        to={`/servicos/${service.code}`}
        className={`text-sm transition-colors flex items-center group ${
          isDarkMode 
            ? 'text-gray-400 hover:text-cyan-400' 
            : 'text-gray-600 hover:text-blue-600'
        }`}
      >
        <ChevronRight 
          size={16} 
          className="mr-1 group-hover:translate-x-1 transition-transform" 
        />
        {service.title}
      </Link>
    </li>
  ))}
</ul>

            </div>
            
            {/* Company */}
            <div>
              <h4 className={`font-bold mb-4 text-lg ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Empresa</h4>
              <ul className="space-y-3">
                <li>
                  <a href="/sobre" className={`text-sm transition-colors flex items-center group ${
                    isDarkMode ? 'text-gray-400 hover:text-cyan-400' : 'text-gray-600 hover:text-blue-600'
                  }`}>
                    <ChevronRight size={16} className="mr-1 group-hover:translate-x-1 transition-transform" />
                    Sobre Nós
                  </a>
                </li>
                <li>
                  <a href="/projectos" className={`text-sm transition-colors flex items-center group ${
                    isDarkMode ? 'text-gray-400 hover:text-cyan-400' : 'text-gray-600 hover:text-blue-600'
                  }`}>
                    <ChevronRight size={16} className="mr-1 group-hover:translate-x-1 transition-transform" />
                    Projectos
                  </a>
                </li>
                <li>
                  <a href="/blog" className={`text-sm transition-colors flex items-center group ${
                    isDarkMode ? 'text-gray-400 hover:text-cyan-400' : 'text-gray-600 hover:text-blue-600'
                  }`}>
                    <ChevronRight size={16} className="mr-1 group-hover:translate-x-1 transition-transform" />
                    Blog
                  </a>
                </li>
                  <li>
                  <a href="/faq" className={`text-sm transition-colors flex items-center group ${
                    isDarkMode ? 'text-gray-400 hover:text-cyan-400' : 'text-gray-600 hover:text-blue-600'
                  }`}>
                    <ChevronRight size={16} className="mr-1 group-hover:translate-x-1 transition-transform" />
                    FAQ
                  </a>
                </li>
              </ul>
            </div>
            
            {/* Contact */}
            <div>
              <h4 className={`font-bold mb-4 text-lg ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Contacto</h4>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <MapPin size={20} className={`mr-3 mt-1 flex-shrink-0 ${
                    isDarkMode ? 'text-cyan-400' : 'text-blue-600'
                  }`} />
                  <div>
                    <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                      Luanda, Município de Viana<br />
                      Angola
                    </p>
                  </div>
                </li>
                <li className="flex items-center">
                  <Mail size={20} className={`mr-3 flex-shrink-0 ${
                    isDarkMode ? 'text-cyan-400' : 'text-blue-600'
                  }`} />
                  <a href="mailto:geral@angonet.ao" className={`text-sm transition-colors ${
                    isDarkMode ? 'text-gray-400 hover:text-cyan-400' : 'text-gray-600 hover:text-blue-600'
                  }`}>
                    geral@angonet.ao
                  </a>
                </li>
                <li className="flex items-center">
                  <Phone size={20} className={`mr-3 flex-shrink-0 ${
                    isDarkMode ? 'text-cyan-400' : 'text-blue-600'
                  }`} />
                  <a href="tel:+244945574552" className={`text-sm transition-colors ${
                    isDarkMode ? 'text-gray-400 hover:text-cyan-400' : 'text-gray-600 hover:text-blue-600'
                  }`}>
                  +244 945 574 552
                  </a>
                </li>
              </ul>

              {/* Newsletter */}
              <div className="mt-6">
                <p className={`text-sm mb-3 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                  Subscreva a nossa newsletter
                </p>
                <div className="flex">
                   <form onSubmit={handleSubmit} className="flex">
  <input
    type="email"
    value={email}
    required
    onChange={(e) => setEmail(e.target.value)}
    placeholder="Seu email"
    className={`flex-1 px-4 py-2 rounded-l-lg text-sm outline-none ${
      isDarkMode
        ? 'bg-white/10 border border-white/20 text-white placeholder-gray-500'
        : 'bg-gray-100 border border-gray-300 text-gray-900 placeholder-gray-500'
    }`}
  />

<button
  type="submit"
  disabled={loadingSubmit}
  className={`px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-r-lg transition-all flex items-center justify-center ${
    loadingSubmit ? 'opacity-70 cursor-not-allowed' : 'hover:shadow-lg'
  }`}
>
  {loadingSubmit ? (
    <Loader size={18} className="animate-spin" />
  ) : (
    <ChevronRight size={20} />
  )}
</button>

</form>

                </div>
              </div>
            </div>
          </div>
          
          {/* Bottom Bar */}
          <div className={`border-t pt-8 ${isDarkMode ? 'border-white/10' : 'border-gray-200'}`}>
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
 <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
  &copy; {new Date().getFullYear()} AngoNet. Todos os direitos reservados.
</p>

              <div className="flex space-x-6">
                <a href="/politicas" className={`text-sm transition-colors ${
                  isDarkMode ? 'text-gray-400 hover:text-cyan-400' : 'text-gray-600 hover:text-blue-600'
                }`}>
                  Política de Privacidade
                </a>
                <a href="/termos" className={`text-sm transition-colors ${
                  isDarkMode ? 'text-gray-400 hover:text-cyan-400' : 'text-gray-600 hover:text-blue-600'
                }`}>
                  Termos de Serviço
                </a>
    
              </div>
            </div>
          </div>
        </div>
 
      </footer>
  );
}
